import BuoyTooltip from '@buoyhealth/common.buoy-tooltip';
import { IconButton } from '@mui/material';
import HelpIcon from '@mui/icons-material/Help';
import { TooltipProps } from '@mui/material/Tooltip';
import React from 'react';
import { Z_INDEX_MAX } from 'src/constants';

interface Props extends Partial<TooltipProps> {
  title: React.ReactNode;
}

const Tooltip = (props: Props) => (
  <BuoyTooltip
    enterTouchDelay={0}
    PopperProps={{
      sx: {
        zIndex: Z_INDEX_MAX,
      },
    }}
    slotProps={{
      tooltip: {
        sx: {
          fontSize: '0.75rem',
          textAlign: 'left',
          padding: '10px',
        },
      },
    }}
    leaveTouchDelay={3000}
    withBuoyTheme
    {...props}
  >
    {props.children || (
      <IconButton
        sx={{
          margin: '-8px', // accounts for padding added for hover effects
          fontSize: '14px',
          color: (theme) => theme.palette.teal[30],
          '&:hover': { color: (theme) => theme.palette.teal[50] },
          alignSelf: 'center',
        }}
        size="small"
      >
        <HelpIcon fontSize="inherit" color="inherit" />
      </IconButton>
    )}
  </BuoyTooltip>
);

export default Tooltip;
